// extracted by css-extract-rspack-plugin
export default {"fileTreeLayout":"Hl7Xph0z9EBAajxX","tableHeader":"DNGaBNhGtNoRx7C9","tableHeaderTitle":"j5SIKCnfHLIOUcti","borderlessList":"Fw2j0yf_pKcEPeBN"};